/**
 * <lumel-countdown>: counts down to the merchant-set date in data-end
 * (e.g. "2026-10-31 23:59", read in the shopper's local time). Shows hours
 * (including whole days), minutes and seconds; when the date passes it hides
 * the timer, or the whole bar with data-hide-bar.
 */
class LumelCountdown extends HTMLElement {
  /** @type {number | undefined} */
  #interval;

  connectedCallback() {
    const raw = (this.dataset.end || '').trim();
    if (!raw) return;

    const end = new Date(raw.replace(' ', 'T')).getTime();
    this.timer = this.querySelector('.lumel-cd__timer');
    if (Number.isNaN(end) || !this.timer) return;

    this.end = end;
    this.#tick();
    this.#interval = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#interval);
  }

  #tick() {
    const left = this.end - Date.now();
    if (left <= 0) {
      window.clearInterval(this.#interval);
      this.timer.hidden = true;
      if (this.hasAttribute('data-hide-bar')) this.hidden = true;
      return;
    }

    const totalSeconds = Math.floor(left / 1000);
    const values = {
      h: Math.floor(totalSeconds / 3600),
      m: Math.floor((totalSeconds % 3600) / 60),
      s: totalSeconds % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const node = this.querySelector(`[data-unit="${unit}"]`);
      if (node) node.textContent = String(value).padStart(2, '0');
    }
    this.timer.hidden = false;
  }
}

if (!customElements.get('lumel-countdown')) customElements.define('lumel-countdown', LumelCountdown);
